var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[(!_vm.is_mobile)?_c('MyPageHistoryDetailPC'):_c('MyPageHistoryDetailSP')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }